export default "__VITE_ASSET__CruAzfFU__"